import React, { useEffect, useState } from 'react'
import './App.css';

import { Routes, Route } from "react-router-dom";
import { BsArrowUp } from "react-icons/bs";
import 'antd/dist/antd.css';
import 'antd/dist/antd.js';
import 'antd/dist/antd.min.css'
import { GoArrowUp } from "react-icons/go";

import 'antd/dist/antd.variable.min.css';

import { lazy } from 'react';

import './assets/css/jetly-dark.css'
import './assets/css/jetly-responsive.css'
import './assets/css/jetly.css'
import arrow from './assets/images/Vector_one.png'

import Passenger from './Components/Passenger/Passenger';
import NotFound from './NotFound';
import { Bell } from './Components/sound';

import Navbar from './Components/Header/Navbar'

import Footer from './Components/Footer/Footer'
import GalleryPage from './Components/Page/GalleryPage/Page'

import Contact from './Components/Page/Contact/Contact'

import News from './Components/Page/News/News'

import Services from './Components/Page/Services/Services'

import Online_table from './Components/Page/Online_table/Online_table'

import Business from './Components/Page/Business/Business'

import Passengers from './Components/Page/Passengers/Passengers'

import About from './Components/Page/About/About'

import News_detail from './Components/Page/News_detail/News_detail'

import Services_detail from './Components/Page/Services_detail/Services_detail'

import Passengers_detail from './Components/Page/Passengers_detail/Passenger_detail'

import Business_detail from './Components/Page/Business_detail/Business_detail'

import Gallery_detail from './Components/Page/Gallery_detail/Gallery_detail'

import About_detail from './Components/Page/About_detail/About_detail'

import BaggageAllowance from './Components/Page/Passengers/BaggageAllowance'

import OnlineTable from './Components/Page/Passengers/OnlineTable'

import BusinessLounge from './Components/Page/Passengers/BusinessLounge'

import ScheduleAirlines from './Components/Page/Passengers/ScheduleAirlines'

import Inside from './Components/Page/Passengers/ScheduleAirlines/Inside'

import Outside from './Components/Page/Passengers/ScheduleAirlines/Outside'

import PreFlightPreview from './Components/Page/Passengers/PreFlightPreview'

import InsideInfo from './Components/Page/Passengers/PreFlightPreview/InsideInfo'

import OutsideInfo from './Components/Page/Passengers/PreFlightPreview/OutsideInfo'

import PassengersRoutes from './Components/Page/Passengers/Routes'


// const HomePage from './Components/Page/HomePage/Page'))
const HomePage = lazy(() => {
  return new Promise(resolve => {
    setTimeout(() => resolve(import("./Components/Page/HomePage/Page")), 3000);
  });
});


function App() {

  const [top, setTop] = useState(false)


  useEffect(() => {

    window.onscroll = () => {
      if (window.scrollY > 400) {
        setTop(true)
      } else {
        setTop(false)
      }
    }
  }, [])


  const back_Top = () => {
    window.scrollTo({
      top: '0',
      behavior: 'smooth'
    })
  }

  return (
    <>
      <div className='App'>
        <div>
          {
            top && <div className='back_top group overflow-hidden w-[46px] h-[46px] flex flex-col justify-center items-center' onClick={back_Top}>
              {/* <GoArrowUp  /> */}
              <img src={arrow} className='topIcon'/>
              {/* <i class="fas fa-angle-right topIcon"></i>  */}
              </div>
          }
        </div>
        <Navbar />
        <div>
          <Routes>
            <Route index element={<HomePage />} />
            <Route path='/news/:id' element={<News_detail />} />
            <Route path='/services/:id' element={<Services_detail />} />
            <Route path='/passengers/:id' element={<Passengers_detail />} />
            <Route path='/business/:id' element={<Business_detail />} />
            <Route path='/gallery/:id' element={<Gallery_detail />} />
            <Route path='/about/:id' element={<About_detail />} />
            <Route path='/gallery' element={<GalleryPage />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/news' element={<News />} />
            <Route path='/services' element={<Services />} />
            <Route path='/online_table' element={<Online_table />} />
            <Route path='/business' element={<Business />} />
            <Route path='/passengers' element={<Passengers />} />
            <Route path='/passengers/routes-and-schedules' element={<PassengersRoutes />} />
            <Route path='/passengers/baggage-allowance' element={<BaggageAllowance/>}/>
            <Route path='/passengers/business-lounge' element={<BusinessLounge/>}/>
            <Route path='/passengers/online-table' element={<OnlineTable/>}/>
            <Route path='/passengers/schedule-airlines' element={<ScheduleAirlines/>}/>
            <Route path='/passengers/schedule-airlines/inside' element={<Inside/>}/>
            <Route path='/passengers/schedule-airlines/outside' element={<Outside/>}/>
            <Route path='/passengers/pre-flight-preview' element={<PreFlightPreview/>}/>
            <Route path='/passengers/pre-flight-preview/inside-info' element={<InsideInfo/>}/>
            <Route path='/passengers/pre-flight-preview/outside-info' element={<OutsideInfo/>}/>
            <Route path='/about' element={<About />} />
            <Route path='/*' element={<NotFound/>} />
          </Routes>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default App;